module.exports = __webpack_public_path__ + "static/media/Wine.3dbb137c.svg";